import { httpServer as http } from "@/http/tbrScanAxios";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

interface DictParams {
  key: string;
  setKey: string;
}

interface DictSet {
  key: string;
  data: any;
}

type DictParamInput = DictParams | string;

@Module({ name: "TbrScanBaseModule", namespaced: true })
export default class TbrScanBaseModule extends VuexModule {
  dictData: any = {};

  @Mutation
  setDictData(dataArr: DictSet[]) {
    dataArr.forEach(item => {
      this.dictData[item.key] = item.data;
    });
  }

  @Action
  async dictQuery(params: DictParams[] | string[]) {
    const normalizedParams: DictParamInput[] = params;
    const transformData = normalizedParams.reduce<Record<string, any>>(
      (acc, param) => {
        if (typeof param === "string") {
          acc[param] = { key: param };
        } else {
          const { key, setKey, ...rest } = param as DictParams;
          acc[key] = {
            key: setKey || key,
            ...rest
          };
        }
        return acc;
      },
      {}
    );

    const dictNames = Object.keys(transformData).join(",");
    const res: any = await http("/k2-scan/dict-i18n/dict-items?dictNames=", {
      dictNames: dictNames
    });
    const { items } = res;
    const flatData = Object.keys(items).flatMap(dictKey => {
      const paramData = transformData[dictKey];
      const original = items[dictKey].map(item => ({
        ...item,
        label: item.desc,
        value: item.code
      }));
      const allLabel = "全部";
      const allValue = paramData.allValue || "";
      const data = paramData.all
        ? [
            {
              label: allLabel,
              value: allValue,
              desc: allLabel,
              code: allValue
            },
            ...original
          ]
        : original;
      return [
        { key: paramData.key, data },
        { key: `${paramData.key}_original`, data: original }
      ] as DictSet[];
    });
    // 4️⃣ 提交
    this.context.commit("setDictData", flatData);
    return flatData;
  }
}
